@if (label()) {
  <label [for]="inputId" class="block text-sm leading-6 font-medium text-gray-900">{{
    label()
  }}</label>
} @else {
  <ng-content select="[slot='label']" />
}
<div
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  (dragenter)="onDragEnter($event)"
  (dragleave)="onDragLeave($event)"
>
  <div
    tabindex="0"
    role="button"
    (keydown.enter)="input.click()"
    (click)="input.click()"
    [class]="$dragging() ? 'border-primary-600' : 'border-gray-300'"
    class="hover:border-primary-600 focus:border-primary-600 mt-2 rounded-lg border border-dashed px-6 py-10 text-center focus:outline-hidden"
  >
    @if (icon(); as value) {
      <wma-icon class="text-primary-600 size-5" [name]="value" />
    } @else {
      <ng-content select="[slot='icon']" />
    }
    <div class="mt-2 flex items-center justify-center text-sm leading-6 text-gray-600">
      <p class="text-balance">{{ 'FILE_INPUT.DRAG_DROP_TEXT' | translate }}</p>
      <input
        #input
        [id]="inputId"
        (change)="onInputChange($event)"
        name="file-input"
        type="file"
        accept="{{ accept() }}"
        class="hidden"
      />
    </div>
    @if (description(); as value) {
      <p class="text-xs leading-5 text-balance text-gray-600">{{ value }}</p>
    } @else {
      <ng-content select="[slot='description']" />
    }
  </div>
</div>

@if ($file(); as file) {
  <wma-file-item class="mt-1" [name]="file.name" [size]="file.size" (clear)="clearFile()" />
}
